import { render, staticRenderFns } from "./publications-block.vue?vue&type=template&id=07422854&"
import script from "./publications-block.vue?vue&type=script&lang=js&"
export * from "./publications-block.vue?vue&type=script&lang=js&"
import style0 from "./publications-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07422854')) {
      api.createRecord('07422854', component.options)
    } else {
      api.reload('07422854', component.options)
    }
    module.hot.accept("./publications-block.vue?vue&type=template&id=07422854&", function () {
      api.rerender('07422854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/news/publications-block.vue"
export default component.exports